import { matchPath, useLocation } from 'react-router';

export const useMatchedRoute = (paths: string[]) => {
  const location = useLocation();

  const matchedIndex = paths.findIndex(path => matchPath(path, location.pathname));

  return {
    match: matchedIndex > -1,
    matchedIndex,
  };
};
